import { render, staticRenderFns } from "./ModelsComparisonResults.vue?vue&type=template&id=22daaed7&"
import script from "./ModelsComparisonResults.vue?vue&type=script&lang=js&"
export * from "./ModelsComparisonResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports